import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import store from "../store";
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/:pathMatch(.*)*", // Matches any unknown route
    redirect: { name: 'Login' }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard, meta: { requiresAuth: true }
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  //adventure routes
  {
    path: "/adventures",
    name: "Adventures",
    component: () => import("../views/AdventureManagement/AdventureList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/adventures/create",
    name: "AdventureCreate",
    component: () => import("../views/AdventureManagement/AdventureCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/adventures/:id/edit",
    name: "AdventureEdit",
    component: () => import("../views/AdventureManagement/AdventureEdit.vue"), meta: { requiresAuth: true },
    props: true, // Pass route params as props
  },

  //tour routes
  {
    path: "/tours",
    name: "Tours",
    component: () => import("../views/TourManagement/TourList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/tours/create",
    name: "TourCreate",
    component: () => import("../views/TourManagement/TourCreate.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/tours/:id/edit",
    name: "TourEdit",
    component: () => import("../views/TourManagement/TourEdit.vue"),
    meta: { requiresAuth: true },
    props: true, // Pass route params as props
  },


  //trips routes
  {
    path: "/trips",
    name: "Trips",
    component: () => import("../views/TripManagement/TripList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/trips/create",
    name: "TripCreate",
    component: () => import("../views/TripManagement/TripCreate.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/trips/:id/edit",
    name: "TripEdit",
    component: () => import("../views/TripManagement/TripEdit.vue"),
    meta: { requiresAuth: true },
    props: true,
  },

  //activity routes
  {
    path: "/activities",
    name: "Activities",
    component: () => import("../views/ActivityManagement/ActivityList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/activities/create",
    name: "ActivityCreate",
    component: () => import("../views/ActivityManagement/ActivityCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/activities/:id/edit",
    name: "ActivityEdit",
    component: () => import("../views/ActivityManagement/ActivityEdit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //PlanYourTrip routes
  {
    path: "/planYourTrip",
    name: "PlanYourTrips",
    component: () => import("../views/PlanYourTripManagement/PlanYourTripList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/planYourTrips/create",
    name: "PlanYourTripCreate",
    component: () => import("../views/PlanYourTripManagement/PlanYourTripCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/planYourTrips/:id/edit",
    name: "PlanYourTripEdit",
    component: () => import("../views/PlanYourTripManagement/PlanYourTripEdit.vue"), meta: { requiresAuth: true },
    props: true,
  },

  //trip questions routes
  {
    path: "/tripQuestions",
    name: "TripQuestions",
    component: () => import("../views/TripQuestionManagement/TripQuestionList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/tripQuestions/create",
    name: "TripQuestionCreate",
    component: () => import("../views/TripQuestionManagement/TripQuestionCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/tripQuestions/:id/edit",
    name: "TripQuestionEdit",
    component: () => import("../views/TripQuestionManagement/TripQuestionEdit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //bookings routes
  {
    path: "/bookings",
    name: "Booking",
    component: () => import("../views/BookingMangement/BookingList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/bookings/:id/show",
    name: "BookingShow",
    component: () => import("../views/BookingMangement/BookingShow.vue"), meta: { requiresAuth: true }
  },

  //contacts routes
  {
    path: "/contacts",
    name: "Contact",
    component: () => import("../views/ContactMangement/ContactList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/contacts/:id/show",
    name: "ContactShow",
    component: () => import("../views/ContactMangement/ContactShow.vue"), meta: { requiresAuth: true }
  },


  //Included routes
  {
    path: "/includedItems",
    name: "IncludedItems",
    component: () => import("../views/IncludedManagement/IncludedList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/includedItems/create",
    name: "IncludedCreate",
    component: () => import("../views/IncludedManagement/IncludedCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/includedItems/:id/edit",
    name: "IncludedEdit",
    component: () => import("../views/IncludedManagement/IncludedEdit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //excluded items routes
  {
    path: "/excludedItems",
    name: "ExcludedItems",
    component: () => import("../views/ExcludedManagement/ExcludedList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/excludedItems/create",
    name: "ExcludedCreate",
    component: () => import("../views/ExcludedManagement/ExcludedCreate.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/excludedItems/:id/edit",
    name: "ExcludedEdit",
    component: () => import("../views/ExcludedManagement/ExcludedEdit.vue"),
    props: true, meta: { requiresAuth: true }
  },

  //adventure activities routes
  {
    path: "/adventureActivities",
    name: "AdventureActivities",
    component: () => import("../views/AdventureActivityManagement/AdventureActivityList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/adventureActivities/:id/edit",
    name: "AdventureActivityEdit",
    component: () => import("../views/AdventureActivityManagement/AdventureActivityEdit.vue"),
    meta: { requiresAuth: true },
    props: true,
  },

  //adventure fitness level routes
  {
    path: "/adventureFitnessLevels",
    name: "AdventureFitnessLevels",
    component: () => import("../views/AdventureFitnessLevelManagement/AdventureFitnessLevelList.vue"), meta: { requiresAuth: true }
  },
  {
    path: "/adventureFitnessLevels/:id/edit",
    name: "AdventureFitnessLevelEdit",
    component: () => import("../views/AdventureFitnessLevelManagement/AdventureFitnessLevelEdit.vue"),
    props: true,
    meta: { requiresAuth: true }

  },

  //adventure fitness level routes
  {
    path: "/adventureTripTypes",
    name: "AdventureTripTypes",
    component: () => import("../views/AdventureTripTypeManagement/AdventureTripTypeList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/AdventureTripTypes/:id/edit",
    name: "AdventureTripTypeEdit",
    component: () => import("../views/AdventureTripTypeManagement/AdventureTripTypeEdit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  if (requiresAuth && !isLoggedIn) {
    console.log('Redirecting to login...');
    next({ name: 'Login' });
  } else {
    next();
  }
});
export default router;
